import { Modal } from "@/components";
import { Grid, Typography, useMediaQuery } from "@mui/material";

function Card({ icon, title, counter, unit, onClick, width = "200px" }) {
  const md = useMediaQuery("(max-width:450px)");

  return (
    <Modal
      titleVariant="body2"
      icon={icon}
      title={title}
      width={md ? "100%" : width}
      onClick={onClick}
    >
      <Grid
        display={"flex"}
        flexDirection={"row"}
        gap={"15px"}
        alignItems={"center"}
        sx={{
          textAlign: "center",
          margin: "10px auto",
          minHeight: md ? "50px" : "unset",
        }}
      >
        <Typography
          variant={
            counter === undefined || counter.toString().length > 5
              ? "body1"
              : "h6"
          }
        >
          {counter}
        </Typography>
        {unit && (
          <Typography variant="caption" color={"var(--emr-text-light)"}>
            {unit}
          </Typography>
        )}
      </Grid>
    </Modal>
  );
}

export default Card;
